import React, { useContext, useState, useEffect } from 'react';
import styles from './Score.module.scss';
import { SettingsContext } from '../../contexts/settings-provider';

import Main from '../../components/Main/Main';
import Section from '../../components/Section/Section';
import ProfileLink from '../../components/ProfileLink/ProfileLink';
import Highscore from '../../components/Highscore/Highscore';
import Logo from '../../components/Logo/Logo';
import Button from '../../components/Button/Button';

const Score = () => {
  const [settings] = useContext(SettingsContext);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    if (settings.user) {
      setSignedIn(true);
    } else {
      setSignedIn(false);
    }
  }, [settings.user]);

  return (
    <Main>
      <Section className={styles.content}>
        {signedIn && <ProfileLink className={styles.profile} />}
        <Logo className={styles.logo} />
        <Highscore length={100} />
        <Button link={'/'}>Back to frontpage</Button>
      </Section>
    </Main>
  );
};

export default Score;
